export const fileToJpeg = (file, max = 1600) => new Promise((resolve, reject) => {
  const img = new Image();
  const src = URL.createObjectURL(file);
  img.onload = () => {
    const c = document.createElement("canvas");
    const scale = Math.min(1, max / Math.max(img.width, img.height));
    c.width = img.width * scale; c.height = img.height * scale;
    c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
    URL.revokeObjectURL(src);
    c.toBlob((b) => (b ? resolve(b) : reject(new Error("convert"))), "image/jpeg", 0.85);
  };
  img.onerror = () => { URL.revokeObjectURL(src); reject(new Error("format")); };
  img.src = src;
});
